import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IAnnouncementResource } from "../types";

export type IAnnouncementQueryParameters = {
    announcement?: RelationalValue<IAnnouncementResource>;
};

export type IAnnouncementQueryResult = IAnnouncementResource;

export const announcementQuery: IApiQueryFunction<IAnnouncementQueryParameters> = ({ announcement }) => {
    if (!announcement) {
        return;
    }

    return {
        method: "GET",
        url: `/announcements/${mapRelationalValue(announcement)}`,
    };
};

export const useAnnouncementQuery = createApiQueryHook<IAnnouncementQueryParameters, IAnnouncementQueryResult>(
    announcementQuery,
);
